
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
    Tab, Table, Button, Icon, Dropdown, Input, Checkbox, Pagination, Popup
} from 'semantic-ui-react';
import {
    despesasDeViagensHistoricoList,
    despesasDeViagensHistoricoListGeral,
    despesasDeViagensGetAjudanteMotoristaAction
} from '../../actions/DespesasDeViagensActions';
import styled from 'styled-components';
import * as XLSX from 'xlsx';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';



const StyledTable = styled(Table)`
  &&& {
    border-spacing: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
    padding: 0px 0px;
   }    
`;

const StyledTableHeader = styled(Table.Header)`
&&& th {
    padding: 0px;
    margin: 0px 0px 0px 0px;
}
`;

const StyledTableBody = styled(Table.Body)`
&&& 
 td{
    padding: 2px 2px !important;
    margin: 0px 0px 0px 0px !important;
}
`;


function Historico(props) {

    const { despesasDeViagensHistoricoList, despesasDeViagensGetAjudanteMotoristaAction, despesasDeViagensHistoricoListGeral } = props // actions
    const { listHistorico, listHistoricoGeral, isLoadingListHistoricoGeral, isLoadingListHistorico, listMotoristaAjudante, isLoadingMotoristaAjudante } = props // reducer


    const [dropdownSelect, setDropdownSelect] = useState(null);
    const [dropdownValue, setDropdownValue] = useState(null);
    const [valueOC, setValueOC] = useState("");
    const [historicoGeralXLS, setHistoricoGeralXLS] = useState(false);
    const [activePage, setActivePage] = useState(1);
    const [totalpages, setTotalPages] = useState(null);
    const [totalRegistros, setTotalRegistros] = useState(null);
    const [dataExpecifica, setDataExpecifica] = useState();
    const [inicio, setInicio] = useState(new Date().setFullYear(new Date().getFullYear() - 1));
    const [fim, setFim] = useState(new Date());

    const dropdownOptions = [
        { text: 'Motorista', value: 1 },
        { text: 'Ajudante', value: 2 },
        { text: 'Todos', value: 10 }
    ];

    useEffect(() => {
        setDropdownSelect(10)
    }, []);

    useEffect(() => {
        if (dropdownSelect === 10) {
            setDropdownValue('');
            setValueOC("");
        }
    }, [dropdownSelect]);


    useEffect(() => {
        const dataPage = {
            page: 1,
            limit: 60,
            inicio: inicio,
            fim: fim
        }
        despesasDeViagensHistoricoList(dataPage).then((data) => {

            console.log('DATA ->', data)
            let page_size = 60;
            let totalpages = Math.ceil(data[0]?.total_registros / page_size);
            console.log(totalpages)
            setTotalPages(totalpages)
        })
        if (dropdownSelect === 10) {
            setDropdownValue('')
        }
    }, [dropdownSelect]);


    const searchMotAjud = (valor) => {
        const data = {
            filtro: valor
        }
        if (valor !== 10) {
            despesasDeViagensGetAjudanteMotoristaAction(data)
        } else {
            setValueOC("")
        }

    }

    const handlePageChange = (e, { activePage }) => {
        setActivePage(activePage);

        let pagination = {
            page: activePage,
            limit: 60,
            inicio: inicio,
            fim: fim
        };
        despesasDeViagensHistoricoList(pagination).then((data) => {

            let page_size = 60;
            let totalpages = Math.ceil(data[0]?.total_registros / page_size);
            console.log(totalpages)
            setTotalPages(totalpages)
        })
    };

    const handleSubmitSearch = () => {


        console.log('HISTORICOXLS ->', historicoGeralXLS);

        let data = {
            filtro: dropdownSelect,
            codparc: dropdownValue !== '' ? dropdownValue : null,
            oc: valueOC,
            historico: historicoGeralXLS,
            page: 1,
            limit: 60,
            inicio: inicio,
            fim: fim
        }

        despesasDeViagensHistoricoList(data).then((data) => {

            let page_size = 60;
            let totalpages = Math.ceil(data[0]?.total_registros / page_size);
            console.log(totalpages)
            setTotalPages(totalpages)
        })

    }

    const motoristaOptions = listMotoristaAjudante.map((item) => {
        if (dropdownSelect === 2) {
            return {
                key: item.idviagemajudante,
                value: item.idviagemajudante,
                text: `${item.viagemajudante} - ${item.idviagemajudante}`
            };
        } else {
            return {
                key: item.codparcmotorista,
                value: item.codparcmotorista,
                text: `${item.motorista} - ${item.codparcmotorista}`
            };
        }
    });

    const handleChangeDropdown = (e, { value }) => {
        console.log('VALOR DROPDOWN ->', value)
        setDropdownSelect(value);

        console.log('DROPDOWN SELECT ->', dropdownSelect)
        searchMotAjud(value);
    };

    const exportToExcel = () => {

        const dataPage = {
            filtro: dropdownSelect,
            codparc: dropdownValue !== '' ? dropdownValue : null,
            oc: valueOC,
            inicio: inicio,
            fim: fim,
            page: 1,
            limit: 0
        }
        despesasDeViagensHistoricoListGeral(dataPage).then((data) => {

            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Fechamento');

            // Exporta o arquivo
            XLSX.writeFile(workbook, `Dados_de_Viagens_de_${moment(inicio).format('DD/MM/YYYY')}_ate_${moment(fim).format('DD/MM/YYYY')}.xlsx`);
        })

        // setHistoricoGeralXLS(true)

        // Cria a planilha e o workbook

    };


    const handleRawChange = (e) => {
        let inputValue = e.target.value;

        // Verifica se o valor contém somente números e tem exatamente 8 dígitos
        if (/^\d{8}$/.test(inputValue)) {
            // Formata a data adicionando "/"
            inputValue = `${inputValue.slice(0, 2)}/${inputValue.slice(2, 4)}/${inputValue.slice(4)}`;
            e.target.value = inputValue; // Atualiza o valor no campo
        }
    };


    return (
        <>
            <div
                style={{
                    display: 'flex',
                    marginBottom: '1rem',
                    marginTop: '2rem',
                    gap: '10px'
                }}
            >

                <Dropdown
                    placeholder='Selecione uma opção'
                    selection
                    options={dropdownOptions}
                    onChange={handleChangeDropdown}
                    loading={isLoadingMotoristaAjudante}
                    selectOnBlur={false}
                />

                <Dropdown
                    placeholder='Selecione um Motorista/Ajudante'
                    selection
                    options={motoristaOptions}
                    selectOnBlur={false}
                    onChange={(e, { value }) => setDropdownValue(value)}
                    disabled={dropdownSelect === 10 ? true : false}
                    value={dropdownValue}
                    search
                // loading={isLoadingMotoristaAjudante}
                />
                <Input
                    labelPosition="left"
                    placeholder="OC"
                    value={valueOC}
                    onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                        }
                    }}
                    onChange={(e) => setValueOC(e.target.value)}
                    style={{ width: '150px' }}
                // error={errors.rota ? true : false}
                />


                <DatePicker
                    selected={inicio}
                    onChange={(date) => { setInicio(date); console.log('DATE ->', date) }}
                    isClearable={true}
                    todayButton={"Hoje"}
                    name="dtinicial"
                    id="dtinicial"
                    dateFormat="dd/MM/yyyy"
                    required={true}
                    value={inicio}
                    placeholderText='Selecione a data inicial'
                    customInput={<Input style={{ marginLeft: '10px' }} />}
                    onChangeRaw={handleRawChange}

                />

                <DatePicker
                    selected={fim}
                    onChange={(date) => setFim(date)}
                    isClearable={true}
                    todayButton={"Hoje"}
                    name="dtfinal"
                    id="dtfinal"
                    dateFormat="dd/MM/yyyy"
                    required={true}
                    value={fim}
                    placeholderText='Selecione a data final'
                    customInput={<Input style={{ marginLeft: '10px' }} />}
                    onChangeRaw={handleRawChange}
                />
                <div>
                    <Button
                        color="blue"
                        onClick={handleSubmitSearch}
                    // loading={isLoadingAdiantamentoLogBusca}
                    // disabled={isLoadingAdiantamentoLogBusca}
                    >
                        <Icon name="search" />
                        Buscar
                    </Button>
                </div>
            </div>
            <div style={{ padding: '10px 10px 10px 0px', width: '100%', display: 'flex', alignItems: 'center' }}>

                <Button loading={isLoadingListHistoricoGeral} color='green' size='mini' onClick={exportToExcel}>
                    Exportar
                    <Icon style={{ marginLeft: '5px' }} name='download' />
                </Button>

            </div>

            <Tab.Pane loading={isLoadingListHistorico}>
                <div>
                    <StyledTable>
                        <StyledTableHeader>
                            <Table.Row style={{}}>
                                <Table.HeaderCell width="1">OC</Table.HeaderCell>
                                <Table.HeaderCell width="1">Veículo</Table.HeaderCell>
                                <Table.HeaderCell width="4">
                                    Motorista&nbsp;
                                    <small style={{ color: 'gray' }}>
                                        (Coloque o mouse para ver detalhes)
                                    </small>
                                </Table.HeaderCell>
                                <Table.HeaderCell width="4">Ajudante</Table.HeaderCell>
                                <Table.HeaderCell width="2">2º Ajudante</Table.HeaderCell>
                                <Table.HeaderCell width="2">Saída</Table.HeaderCell>
                                <Table.HeaderCell width="2">Chegada</Table.HeaderCell>
                                <Table.HeaderCell width="2">Valor</Table.HeaderCell>
                            </Table.Row>
                        </StyledTableHeader>

                        {listHistorico.map((item) => (
                            <StyledTableBody >
                                <Table.Cell>{item.ordemcarga}</Table.Cell>
                                <Table.Cell>{item.placa}</Table.Cell>
                                <Popup
                                    trigger={
                                        <Table.Cell>
                                            {item.motorista}
                                        </Table.Cell>
                                    }
                                    flowing
                                    hoverable
                                    on={["hover", "click"]}
                                >
                                    <p>Motorista: <b>{item.motorista}</b></p>
                                    <table border='1px' style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ padding: '4px', textAlign: 'left', backgroundColor: '#f2f2f2', borderBottom: '1px solid #ddd' }}><b>OC</b></th>
                                                <th style={{ padding: '4px', textAlign: 'left', backgroundColor: '#f2f2f2', borderBottom: '1px solid #ddd' }}>NUFIN</th>
                                                <th style={{ padding: '4px', textAlign: 'left', backgroundColor: '#f2f2f2', borderBottom: '1px solid #ddd' }}>VALOR</th>
                                                <th style={{ padding: '4px', textAlign: 'left', backgroundColor: '#f2f2f2', borderBottom: '1px solid #ddd' }}>NATUREZA</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {item.ordensDeCarga.map(itempopup => (
                                                <tr
                                                    key={itempopup.ordemcarga}
                                                >
                                                    <td style={{ padding: '4px', borderBottom: '1px solid #ddd' }}>{itempopup.ordemcarga}</td>
                                                    <td style={{ padding: '4px', borderBottom: '1px solid #ddd' }}>{itempopup.nufin}</td>
                                                    <td style={{ padding: '4px', borderBottom: '1px solid #ddd' }}>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(itempopup.valorespopup)}</td>
                                                    <td style={{ padding: '4px', borderBottom: '1px solid #ddd' }}>{itempopup.natureza}</td>
                                                </tr>
                                            ))}

                                            {/* Calculando o total ajustado */}
                                            {(() => {
                                                const totalAdiantamentos = item.ordensDeCarga
                                                    .filter(itempopup => itempopup.natureza === "Adiantamento")
                                                    .reduce((acc, curr) => acc + curr.valorespopup, 0);

                                                const totalRecalculado = item.valoresdob - totalAdiantamentos;

                                                return (
                                                    <>
                                                        {Object.entries(item.totalPorOrdemDeCarga[0]).map(([chave, valor]) => (
                                                            <tr key={chave}>
                                                                <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }} colSpan={2} align='right'><b>Total OC {chave}:</b></td>
                                                                <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor)}</td>
                                                            </tr>
                                                        ))}
                                                        {/* <tr>
                                                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }} colSpan={2} align='right'><b>Total:</b></td>
                                                            <td style={{ padding: '8px', borderBottom: '1px solid #ddd' }}>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.valor)}</td>
                                                        </tr> */}
                                                    </>
                                                );
                                            })()}
                                        </tbody>
                                    </table>
                                </Popup>
                                <Table.Cell>{item.ajudante}</Table.Cell>
                                <Table.Cell>{item.ajudante_duplo}</Table.Cell>
                                <Table.Cell>
                                    <Popup
                                        trigger={
                                            <Table.Cell>
                                                {new Date(item.saida).toLocaleDateString('pt-BR', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                })}
                                            </Table.Cell>
                                        }
                                        flowing
                                        hoverable
                                        on={["hover", "click"]}
                                    >
                                        {item.user_saida}
                                    </Popup>


                                </Table.Cell>
                                <Table.Cell>
                                    <Popup
                                        trigger={
                                            <Table.Cell>
                                                {new Date(item.chegada).toLocaleDateString('pt-BR', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                })}
                                            </Table.Cell>
                                        }
                                        flowing
                                        hoverable
                                        on={["hover", "click"]}
                                    >
                                        {item.user_chegada}
                                    </Popup>

                                </Table.Cell>
                                <Table.Cell>
                                    {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.valor)}
                                </Table.Cell>
                            </StyledTableBody>

                        ))}

                    </StyledTable>
                </div>
            </Tab.Pane>
            {historicoGeralXLS ? ('') : (
                <div style={{ textAlign: 'right', marginTop: '15px' }}>
                    <Pagination
                        boundaryRange={0}
                        defaultActivePage={1}
                        ellipsisItem={null}
                        firstItem={1}
                        lastItem={totalpages}
                        siblingRange={1}
                        totalPages={totalpages}
                        activePage={activePage} // Vincula o estado da página ativa
                        onPageChange={handlePageChange} // Chama o manipulador ao mudar de página
                    />
                </div>
            )}

        </>
    );
}


const mapStateToProps = (state) => ({
    listHistorico: state.DespesasDeViagensReducer.listHistorico,
    isLoadingListHistorico: state.DespesasDeViagensReducer.isLoadingListHistorico,
    listHistoricoGeral: state.DespesasDeViagensReducer.listHistoricoGeral,
    isLoadingListHistoricoGeral: state.DespesasDeViagensReducer.isLoadingListHistoricoGeral,
    listMotoristaAjudante: state.DespesasDeViagensReducer.listMotoristaAjudante,
    isLoadingMotoristaAjudante: state.DespesasDeViagensReducer.isLoadingMotoristaAjudante,
});

export default withRouter(connect(mapStateToProps, {
    despesasDeViagensHistoricoList,
    despesasDeViagensHistoricoListGeral,
    despesasDeViagensGetAjudanteMotoristaAction
})(Historico)
);